import { render, staticRenderFns } from "./BulkMAD.vue?vue&type=template&id=b4b6d568&scoped=true&"
import script from "./BulkMAD.vue?vue&type=script&lang=js&"
export * from "./BulkMAD.vue?vue&type=script&lang=js&"
import style0 from "./BulkMAD.vue?vue&type=style&index=0&id=b4b6d568&scoped=true&lang=css&"
import style1 from "./BulkMAD.vue?vue&type=style&index=1&id=b4b6d568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b6d568",
  null
  
)

export default component.exports